import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clapperboard, MapPin, X } from "lucide-react";
import { todayIstIso } from "@/utils/date";

const fmt = (iso) => { const [y, m, d] = iso.split("-"); return `${d}/${m}/${y.slice(2)}`; };
const when = (n) => (n === 0 ? "Today" : n === 1 ? "Tomorrow" : `In ${n} days`);
const slotKey = () => `lim-shoot-rem-hide:${todayIstIso()}:${new Date().getHours() * 60 + new Date().getMinutes() >= 17 * 60 ? "pm" : "am"}`;

// Upcoming shoots/bookings (next 2 days) for Shoot Team + Amit; hiding lasts until the next reminder slot.
export function ShootReminderCard({ items }) {
  const nav = useNavigate();
  const [hidden, setHidden] = useState(() => !!localStorage.getItem(slotKey()));
  if (!items.length || hidden) return null;
  return (
    <div className="rounded-xl border border-violet-500/40 bg-surface shadow-float p-3 animate-fade-in-up" data-testid="nudge-shoot-reminders">
      <div className="flex items-center gap-2 mb-1.5">
        <Clapperboard size={16} className="text-violet-500 shrink-0" />
        <div className="text-sm font-semibold flex-1">Upcoming shoots</div>
        <button type="button" onClick={() => { localStorage.setItem(slotKey(), "1"); setHidden(true); }} data-testid="nudge-shoot-reminders-hide"
          title="Hide until the next reminder" className="h-6 w-6 grid place-items-center rounded hover:bg-white/5"><X size={13} /></button>
      </div>
      <div className="space-y-1.5">
        {items.map((e) => (
          <button key={`${e.kind}-${e.id}`} type="button" onClick={() => nav(e.url)} data-testid={`nudge-shoot-item-${e.kind}-${e.id}`}
            className="w-full text-left rounded-md border border-white/10 px-2 py-1.5 hover:bg-white/5 transition-colors">
            <div className="flex items-center gap-2 text-xs">
              <span className={`font-semibold ${e.days_until === 0 ? "text-red-600 dark:text-red-400" : "text-violet-600 dark:text-violet-300"}`}>{when(e.days_until)}</span>
              <span className="text-white/50 font-mono">{fmt(e.date)}{e.time ? ` · ${e.time}` : ""}</span>
              <span className="ml-auto text-[10px] uppercase tracking-wider text-white/40">{e.kind === "shoot" ? "Shoot" : "Studio"}</span>
            </div>
            <div className="client-line text-sm truncate">{e.client}</div>
            {e.location && <div className="text-[11px] text-white/50 truncate flex items-center gap-1"><MapPin size={10} />{e.location}</div>}
          </button>
        ))}
      </div>
    </div>
  );
}
